import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, TextField } from "@mui/material";
import { getWorkersPaginated } from "../../api/apiCall";
import { useAuth } from "../../auth/auth";
import { useForm } from "react-hook-form";
import { useUKRailWeek } from "../../hooks/useUKRailWeek";

const FatigueCalculation = () => {
  const { state } = useAuth();
  const [workers, setWorkers] = useState<any>([]);
  const {currentWeek} = useUKRailWeek()
  const [loading, setLoading] = useState(false);
  const today = new Date();

  const { register, handleSubmit, watch } = useForm<any>({
    defaultValues: {
      startWeek: currentWeek,
      endWeek: currentWeek,
      year: today.getFullYear(),
      query: "",
      page: 0,
      itemsPerPage: 0,
    },
  });

  const watchFields = watch();

  const getWorkers = async (data: any) => {
    try {
      setLoading(true);
      const response: any = await getWorkersPaginated(state.user?.token, data);
      setWorkers(response || []);
    } catch (error) {
      console.error("Failed to fetch workers:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = (userId: any) => {
    const url =
      `/pace-team/fatigue-calculations/fatigue-user?workerId=${userId}&startWeek=${watchFields.startWeek}&endWeek=${watchFields.endWeek}&year=${watchFields.year}`;
    window.open(url, "_blank");
  };

  const columns: any = [
    {
      field: "name",
      headerName: "Full Name",
      flex: 1,
      renderCell: (params: any) => (
        <div
          onClick={() => handleClick(params.row.id)}
          style={{ cursor: "pointer" }}
        >
          {params.row.name} {params.row.surname}
        </div>
      ),
    },
    { field: "pts", headerName: "PTS", flex: 1, align: "center", headerAlign: "center" },
    { field: "phoneNumber", headerName: "Phone Number", flex: 1, align: "center", headerAlign: "center" },
    { field: "dutiesCount", headerName: "Total Shifts", flex: 1, align: "center", headerAlign: "center" },
    {
      field: 'fatigueIndex',
      headerName: 'Fatigue Index',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const fatigue = params.row.fatigueIndex;

        if (fatigue === -1 || fatigue === null || fatigue === undefined) {
          return (
            <div style={{ color: '#333' }}>
              Not Calculated
            </div>
          );
        }

        const value = fatigue.toFixed(1);
        const isHigh = fatigue > 45;

        return (
          <div
            style={{
              fontWeight: 'bold',
              color: isHigh ? 'red' : 'green',
            }}
          >
            {value}
          </div>
        );
      },
    },
    {
      field: 'riskIndex',
      headerName: 'Risk Index',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const risk = params.row.riskIndex;

        if (risk === -1 || risk === null || risk === undefined) {
          return (
            <div style={{ color: '#333' }}>
              Not Calculated
            </div>
          );
        }

        const value = risk.toFixed(2);
        const isHigh = value > 1.60;

        return (
          <div
            style={{
              fontWeight: 'bold',
              color: isHigh ? 'red' : 'green',
            }}
          >
            {value}
          </div>
        );
      },
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => (
        <Button
          variant="contained"
          onClick={() => handleClick(params.row.id)}
          style={{
            boxShadow: "none",
            backgroundColor: "#6c757d",
          }}
        >
          Details
        </Button>
      ),
    },
  ];

  const { query, startWeek, endWeek, year} = watch();

  useEffect(() => {
    const controller = new AbortController();

    const timeout = setTimeout(() => {
      getWorkers({ query, startWeek, endWeek, year, signal: controller.signal });
    }, 500);

    return () => {
      clearTimeout(timeout);
      controller.abort();
    };
  }, [query, startWeek, endWeek, year]);

  useEffect(() => {
    getWorkers({});
  }, []);

  return (
    <>
      <div className="form-content">
        <TextField
          label="Full Name or PTS"
          type="text"
          size="small"
          {...register("query")}
          style={{ width: "15%", margin: 10 }}
        />
        <TextField
          label="Start Week"
          variant="outlined"
          type="number"
          {...register("startWeek")}
          size="small"
          style={{ margin: 10, width: "15%" }}
        />
        <TextField
          label="End Week"
          variant="outlined"
          type="number"
          {...register("endWeek")}
          size="small"
          style={{ margin: 10, width: "15%" }}
        />
        <TextField
          label="Year"
          variant="outlined"
          type="number"
          {...register("year")}
          size="small"
          style={{ margin: 10, width: "15%" }}
        />
        <Button
          variant="contained"
          onClick={handleSubmit(getWorkers)}
          style={{
            height: 40,
            margin: 10,
            boxShadow: "none",
            width: "15%",
          }}
        >
          Filter
        </Button>
      </div>

      <Box sx={{ height: "800px", width: "78.5%", margin: "0 auto" }} mt={3} mb={3}>
        <DataGrid
          rows={workers}
          columns={columns}
          loading={loading}
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: { pageSize: 100 },
            },
          }}
          pageSizeOptions={[100]}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              fontSize: 15,
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#f0f0f0",
              color: "#000",
              fontWeight: "bold",
            },
          }}
        />
      </Box>
    </>
  );
};

export default FatigueCalculation;
